/**
 * @file Frontend API client — dropdownService.
 */

import axiosClient from "../api/axiosClient";
import { Dropdown } from "../interfaces/dropdownInterfaces";

/** Exported const — dropdown Service. */
export const dropdownService = {
  getAll: async (): Promise<Dropdown[]> => {
    const res = await axiosClient.get("/dropdowns");
    return res.data;
  },

  createDropdown: async (name: string, description?: string) => {
    const res = await axiosClient.post("/dropdowns", { name, description });
    return res.data;
  },

  deleteDropdown: async (id: number) => {
    await axiosClient.delete(`/dropdowns/${id}`);
  },

  addOption: async (
    dropdownId: number,
    label: string,
    value: string,
    DQI_Score?: number
  ) => {
    const res = await axiosClient.post(`/dropdowns/${dropdownId}/options`, {
      label,
      value,
      DQI_Score,
    });
    return res.data;
  },

  updateOption: async (
    optionId: number,
    label: string,
    value: string,
    DQI_Score?: number | null
  ) => {
    const res = await axiosClient.put(`/dropdowns/options/${optionId}`, {
      label,
      value,
      DQI_Score,
    });
    return res.data;
  },

  deleteOption: async (optionId: number) => {
    await axiosClient.delete(`/dropdowns/options/${optionId}`);
  },
};
